
/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const GET_SUBENTERPRISES = "GET_SUBENTERPRISES";
export const SET_FILTERED_SUBENTERPRISES = "GET_FILTERED_SUBENTERPRISES";
export const SET_SELECTED_SUBENTERPRISE = "GET_SELECTED_SUBENTERPRISE";
export const ADD_SUBENTERPRISE = "ADD_SUBENTERPRISE";
export const SET_ENTITLEMENTS_FOR_SUBENTERPRISE = "SET_ENTITLEMENTS_FOR_SUBENTERPRISE";
export const RESET_SUBENTERPRISES = "RESET_SUBENTERPRISES";
